var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.335 4.905v-.822c0-1.093-.823-2.083-1.96-2.083h-4.75c-1.137 0-1.96.99-1.96 2.083v.822H5.116C3.61 4.905 2.5 6.236 2.5 7.73v2.02c0 1.657.843 2 2.5 2h1v-.25c0-1.38.62-2 2-2s2 .62 2 2v.25h4v-.25c0-1.38.62-2 2-2s2 .62 2 2v.25h1c1.657 0 2.5-.343 2.5-2V7.73c0-1.494-1.108-2.825-2.616-2.825h-2.55ZM9.716 3.49c-.124 0-.323.129-.323.417v1h5.214v-1c0-.288-.2-.417-.323-.417H9.716Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 12.785V13c0 1.38.62 2 2 2s2-.62 2-2v-.215h1.379c1.447 0 2.121-.174 2.121-1.621v8.103c0 1.445-1.104 2.733-2.607 2.733H5.107C3.604 22 2.5 20.712 2.5 19.267v-8.103c0 1.447.674 1.621 2.121 1.621H6V13c0 1.38.62 2 2 2s2-.62 2-2v-.215h4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 11.5a1 1 0 1 1 2 0V13a1 1 0 1 1-2 0v-1.5Zm-8 0a1 1 0 1 1 2 0V13a1 1 0 1 1-2 0v-1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.7daab483e1ad8d622a245c15d7801d04.svg";
export { ForwardRef as ReactComponent };